import * as React from "react";
const SvgDropdownArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 7, viewBox: "0 0 10 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L5 5L9 1", stroke: "#FFDE67", strokeWidth: 2 }));
export default SvgDropdownArrow;
